import { useEffect, useState } from 'react';
import { sendGlobalTrackingThunk } from '../core/thunks.js';
import { useAppDispatch, useAppSelector } from './redux/index.js';
import { rememberMeSelector } from '../forms/Login/loginSlice.js';
import { generateFacebookTrackingPayload } from '../tracking/helpers/generateFacebookTrackingPayload.js';
import { selectActiveForm } from '../core/navigation/navigationSlice.js';
import { trackingTwoStepLoginRegistrationStateSelector } from '../forms/TwoStepLoginRegistration/twoStepLoginRegistrationSlice.js';
export const useSendFacebookTrackingScript = (formType) => {
    const [trackingEventState, setTrackingEventState] = useState('initial');
    const dispatch = useAppDispatch();
    const checkboxState = useAppSelector(rememberMeSelector);
    const activeForm = useAppSelector(selectActiveForm);
    const twoStepComponentState = useAppSelector(trackingTwoStepLoginRegistrationStateSelector);
    useEffect(() => {
        if (trackingEventState !== 'initial') {
            const [payloadGeneratingFunction, payloadOverwrites] = generateFacebookTrackingPayload(trackingEventState, formType, checkboxState, activeForm, twoStepComponentState);
            dispatch(sendGlobalTrackingThunk(payloadGeneratingFunction, payloadOverwrites));
        }
    }, [trackingEventState]);
    return { setTrackingEventState };
};
//# sourceMappingURL=useSendFacebookTracking.js.map